import { API_ENDPOINTS } from '../config/api';

const BASE_URL = API_ENDPOINTS.USERS;

class UserService {
    async apiCall(endpoint, options = {}) {
        try {
            const fullUrl = `${BASE_URL}${endpoint}`;
            console.log('userService.apiCall:', { fullUrl, options });

            const response = await fetch(fullUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers
                },
                ...options
            });

            console.log('userService.apiCall response:', {
                status: response.status,
                statusText: response.statusText,
                ok: response.ok
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error('userService.apiCall error response:', errorText);
                throw new Error(`HTTP error! status: ${response.status}: ${errorText}`);
            }

            const result = await response.json();
            console.log('userService.apiCall success result:', result);
            return result;
        } catch (error) {
            console.error('userService.apiCall failed:', error);
            throw error;
        }
    }

    // Get all active users
    async getAllUsers() {
        return this.apiCall('');
    }

    // Get only users who can do weekend duty
    async getWeekendDutyUsers() {
        return this.apiCall('/weekend-duty');
    }

    // Create a new user
    async createUser(userData) {
        return this.apiCall('', {
            method: 'POST',
            body: JSON.stringify(userData)
        });
    }

    // Update an existing user
    async updateUser(id, userData) {
        console.log('userService.updateUser called with:', { id, userData });
        const result = await this.apiCall(`/${id}`, {
            method: 'PUT',
            body: JSON.stringify(userData)
        });
        console.log('userService.updateUser result:', result);
        return result;
    }

    // Soft delete a user (mark as inactive)
    async deleteUser(id) {
        return this.apiCall(`/${id}`, {
            method: 'DELETE'
        });
    }

    // Test connection to user API
    async testConnection() {
        try {
            const response = await fetch(`${BASE_URL}`);
            return response.ok;
        } catch (error) {
            console.error('User API connection test failed:', error);
            return false;
        }
    }
}

const userService = new UserService();
export default userService;
